(() => {
  const toggle = document.querySelector("[data-pp-menu-toggle]");
  const menu = document.querySelector("[data-pp-menu]");

  if (toggle && menu) {
    const closeMenu = ({ returnFocus = false } = {}) => {
      toggle.setAttribute('aria-expanded', 'false');
      menu.dataset.open = 'false';
      document.body.classList.remove('pp-menu-open');
      if (returnFocus) toggle.focus();
    };

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMenu();
        return;
      }

      toggle.setAttribute('aria-expanded', 'true');
      menu.dataset.open = 'true';
      document.body.classList.add('pp-menu-open');
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu({ returnFocus: true });
      }
    });
  }

  document.querySelectorAll('.pp-products').forEach((section) => {
    const rail = section.querySelector('[data-product-rail]');
    const previous = section.querySelector('[data-rail-previous]');
    const next = section.querySelector('[data-rail-next]');
    if (!rail || !previous || !next) return;

    const move = (direction) => {
      const card = rail.querySelector('.pp-product-card');
      const distance = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  const previewNewsletter = document.querySelector('[data-preview-newsletter]');
  if (previewNewsletter) {
    previewNewsletter.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = previewNewsletter.querySelector('[data-preview-message]');
      if (message) {
        message.hidden = false;
        message.focus();
      }
    });
  }
})();
